<hb-table
  *ngIf="currentAvailableItems"
  id="maintenance-strategy-planned-maintenance-dialog"
  [data]="currentAvailableItems"
  [config]="config"
  (loadLazy)="loadAvailableMaintenanceLazy($event)"
  [selectedItems]="selectedMaintenance"
  (selectionChange)="selectionChange($event)"
>
</hb-table>